<app-slider [currentSliderEndValue]="currentSliderEndValue()" [currentSliderStartValue]="currentSliderStartValue()" [showAdditionalTooltips]="showAdditionalTooltips()" [minStart]="minStart()" [maxEnd]="maxEnd()" [(startValue)]="startValue" [(endValue)]="endValue"
  (valueChange)="onValueChange()"></app-slider>
